import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0d8abeda"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传文件");

const _hoisted_2 = {
  class: "image-slot"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("  秒 （最长只能设置10秒） ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部团队");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("部分团队");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加团队");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { dateFormat } from '@/config';
import { addAppStarup, getAppStarupConfigureList } from '@/request';
import { ElMessage } from 'element-plus';
import AddTeamModal from '@/components/AddTeamModal.vue';
import { arrayRemoveRepeatByProp } from '@/utils';
export default {
  name: 'AddStarUpPageModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const uploadRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const formRef = ref();
    const scroll = ref();
    const form = ref({
      fileName: '',
      targetUrl: '',
      residenceTime: 0,
      fileURl: '',
      pic_file: '',
      endTime: '',
      startTime: '',
      activityName: '',
      activityStatus: '',
      supplierFlag: 1
    });
    watch(() => props.modelValue, newVal => {
      scroll.value.setScrollTop(0);

      if (newVal && !props.editData) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        uploadRef.value.clearFiles();
        form.value = {
          fileName: '',
          targetUrl: '',
          residenceTime: 0,
          fileURl: '',
          pic_file: '',
          endTime: '',
          time: '',
          startTime: '',
          activityName: '',
          activityStatus: '',
          supplierFlag: 1
        };
      }

      if (newVal && props.editData) {
        getDetail();
        form.value = _objectSpread(_objectSpread({
          fileName: decodeURIComponent(props.editData.picUrl).split('/').pop(),
          targetUrl: '',
          pic_file: '',
          endTime: '',
          time: [props.editData.startTime, props.editData.endTime],
          startTime: '',
          activityName: '',
          activityStatus: ''
        }, props.editData), {}, {
          residenceTime: Number(props.editData.residenceTime),
          fileURl: props.editData.picUrl,
          supplierFlag: props.editData.supplierFlag
        });
      }
    }, {
      flush: 'post'
    });

    function validUrl(rule, val, cb) {
      if (val && !/^http(s)?:\/\//.test(val)) {
        cb(new Error());
        return;
      }

      cb();
    }

    function uploadChange(file) {
      if (file.size / 1024 / 1024 > 1.6) {
        ElMessage.error('文件大小不可超过 1.6MB!');
        return;
      }

      form.value.fileName = file.name;
      form.value.pic_file = file.raw;
      form.value.fileURl = URL.createObjectURL(new Blob([file.raw], {
        type: 'image/png'
      }));
    }

    function confirm() {
      formRef.value.validate(result => {
        if (result) {
          let body = _objectSpread({}, form.value);

          delete body.receiveSuppliers;
          delete body.supplierIds;
          delete body.supplierNames;
          delete body.picUrl;

          if (form.value.supplierFlag === 2 && tableData.value.length) {
            // formdata.append('supplierIds', tableData.value.map(v => v.supplier_id))
            body.supplierIds = tableData.value.map(v => v.supplier_id).join();
          } // console.log(body)
          // return


          addAppStarup(_objectSpread(_objectSpread({}, body), {}, {
            __warn: true,
            __repeat: true
          })).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              emit('success');
            }
          });
        }
      });
    } // 团队列表


    const table = ref();
    const tableData = ref([]);
    const tableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '团队名称',
        field: 'supplier_name',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员数量',
        field: 'salesman_num'
      }, {
        title: '联系人',
        field: 'link_man'
      }, {
        title: '联系电话',
        field: 'link_phone'
      }, {
        title: '业务区域',
        field: 'businessAreaName',
        showOverflow: true
      }]
    };
    const showAddTeamModal = ref(false);

    function addTeamSuccess(row) {
      tableData.value = arrayRemoveRepeatByProp((tableData.value || []).concat(row), 'id');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      tableData.value = tableData.value.filter(row => selectRows.every(select => select.supplier_id !== row.supplier_id));
    } // 获取详情


    function getDetail() {
      getAppStarupConfigureList({
        activityId: props.editData.activityId
      }).then(res => {
        let list = res.rows[0].receiveSuppliers || [];
        tableData.value = list.map(item => ({
          supplier_name: item.supplierName,
          salesman_num: item.salesmanNumbs,
          link_man: item.linkMan,
          link_phone: item.linkPhone,
          businessAreaName: item.businessAreaName,
          supplier_id: item.supplierId
        }));
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_PictureFilled = _resolveComponent("PictureFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? '编辑' : '新增',
        top: "30px",
        width: "80%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "活动名称",
              prop: "activityName",
              rules: {
                required: true,
                message: '请输入活动名称'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.activityName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.activityName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "活动开始时间",
              prop: "startTime",
              rules: {
                required: true,
                message: '请选择活动开始时间'
              }
            }, {
              default: _withCtx(() => [!__props.editData ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 0,
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.startTime = $event),
                type: "date",
                "start-placeholder": "开始时间",
                "end-placeholder": "开始时间",
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])) : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event)
              }, null, 8, ["modelValue"]))]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "活动结束时间",
              prop: "endTime",
              rules: {
                required: true,
                message: '请选择活动结束时间'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                type: "date",
                "start-placeholder": "结束时间",
                "end-placeholder": "结束时间",
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "选择文件",
              prop: "fileName",
              rules: {
                required: true,
                message: '请上传文件'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "300px"
                },
                readonly: "",
                modelValue: form.value.fileName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.fileName = $event)
              }, null, 8, ["modelValue"]), _createVNode(_component_el_upload, {
                ref_key: "uploadRef",
                ref: uploadRef,
                multiple: false,
                "show-file-list": false,
                "on-change": uploadChange,
                "auto-upload": false
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, null, {
                  default: _withCtx(() => [_hoisted_1]),
                  _: 1
                })]),
                _: 1
              }, 512)]),
              _: 1
            }), _createVNode(_component_el_alert, {
              style: {
                "margin-top": "10px"
              },
              title: "要求图片尺寸为1125*2436px，格式为jpg、png、mp4；图片控制在400KB以内；\r\n          视频mp4控制在1.6MB以内",
              type: "warning"
            }), _createVNode(_component_el_image, {
              class: "image",
              src: form.value.fileURl,
              style: {
                "width": "300px",
                "height": "300px"
              },
              fit: "contain",
              previewSrcList: [form.value.fileURl]
            }, {
              error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
                _: 1
              })])]),
              _: 1
            }, 8, ["src", "previewSrcList"]), _createVNode(_component_el_form_item, {
              label: "跳转链接",
              prop: "targetUrl",
              rules: {
                validator: validUrl,
                message: '链接以http:// 或 https:// 开头'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.targetUrl,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.targetUrl = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_el_form_item, {
              prop: "residenceTime",
              label: "停留时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.residenceTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.residenceTime = $event),
                min: 1,
                max: 10
              }, null, 8, ["modelValue"]), _hoisted_3]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "supplierFlag",
              label: "接收团队",
              rules: {
                required: true,
                message: '请选择接收团队'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.value.supplierFlag,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.supplierFlag = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_4]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_hoisted_5]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _withDirectives(_createVNode(_component_vxe_grid, _mergeProps(tableOptions, {
              data: tableData.value,
              ref_key: "table",
              ref: table
            }), {
              tools: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_button, {
                icon: "Plus",
                type: "primary",
                onClick: _cache[8] || (_cache[8] = $event => showAddTeamModal.value = true)
              }, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Delete",
                type: "danger",
                onClick: del
              }, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              })], 512), [[_vShow, !_ctx.see]])]),
              _: 1
            }, 16, ["data"]), [[_vShow, form.value.supplierFlag === 2]])]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 512), _createVNode(AddTeamModal, {
          modelValue: showAddTeamModal.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showAddTeamModal.value = $event),
          onSuccess: addTeamSuccess
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};